"use strict";

/**
* Класс для реквизита типа «Дата».
* 
* @class WebAccess.components.wrappers.form.requisites._details.Date
* @extends WebAccess.components.wrappers.form.requisites.Date
* @mixes WebAccess.components.wrappers.form.requisites._details.editModeMixin
* @private
* @since 5.2.0.1300
*/
(function (global) {

  const Date = global.Date.extend([global._details.editModeMixin], {
    className: 'DetailDate',

    /**
     * Показывается ли время в реквизите.
     *
     * @method WebAccess.components.wrappers.form.requisites._details.Date#isShowTime
     * @return {boolean} True – реквизит показывает время, иначе False.
     * @since 5.2.0.2006
     */
    isShowTime: function () {
      var me = this;
      if (me.isEditMode) {
        return me._super();
      }
      var cols = me._grid._columns;
      var curCol = _(cols).findWhere({ 'id': me.name });
      if (curCol) {
        return curCol.dateType === 'DateTime';
      } else {
        return false;
      }
    }
  });

  global._details.Date = Date;
})(window.WA.CMP.wrappers.form.requisites);


